import { Button, Tabs } from "@mantine/core";
import React from "react";
import html from "../../../images/technology/html.ec102b63.ec102b633e2349ebebaa.png";

import bootstrap from "../../../images/technology/bootstrap.png";
import cloudinary from "../../../images/technology/cloudinary.png";
import css from "../../../images/technology/css.29013fe6.29013fe635e1a5441f11.png";
import express from "../../../images/technology/express.483b10d6.483b10d681a9c51431b7.png";
import github from "../../../images/technology/github.caeb9ff8.caeb9ff86e1c3e87612e.png";
import heroku from "../../../images/technology/heroku.png";
import js from "../../../images/technology/js.png";
import mui from "../../../images/technology/metarial ui.4ee24f56.4ee24f56e2960e63b7dc.png";
import mongodb from "../../../images/technology/mongodb.70c82e5a.70c82e5ad6bbb2533be4.png";
import node from "../../../images/technology/node js.8030f6dd.8030f6dd22521410731e.png";
import nodemailer from "../../../images/technology/nodemiler.png";
import react from "../../../images/technology/react.35639ed9.35639ed930462bfcd544.png";
import redux from "../../../images/technology/redux.png";
import tailwind from "../../../images/technology/tailwind.png";

import elementor from "../../../images/technology/elementor.png";
import webb from "../../../images/technology/webb.png";
import woocommerce from "../../../images/technology/woocommerce.png";
import wordpress from "../../../images/technology/wordpress.png";

import astra from "../../../images/technology/astra.png";
import divi from "../../../images/technology/divi.png";
import mailchimp from "../../../images/technology/mailchimp.png";
import pro from "../../../images/technology/pro.png";
import protheme from "../../../images/technology/protheme.jpeg";
function AboutTechnoloy() {
  return (
    <div className="about-technology-background-wrapper">
      <div className="padding_container">
        <div className="technolohy-area">
          <div className="top">
            <h1>My solid and versatile technology stack</h1>
          </div>

          <div className="tab-area">
            <Tabs defaultValue="first">
              <Tabs.List position="center">
                <Tabs.Tab value="first">
                <Button variant="light" gradient={{ from: 'indigo', to: 'cyan' }}>Frontend</Button>

                
                </Tabs.Tab>
                <Tabs.Tab value="second">
                <Button variant="light" gradient={{ from: 'indigo', to: 'cyan' }}>Backend</Button>
                </Tabs.Tab>
                <Tabs.Tab value="third">
                <Button variant="light" gradient={{ from: 'indigo', to: 'cyan' }}>Wordpress</Button>
                </Tabs.Tab>
              </Tabs.List>

        {/* frontend  */}
              <Tabs.Panel value="first" pt="xs">
                <div className="technology_grid">
                        <div className="item">
                            <div className="image-area">
                                <img src={html} alt="" />
                            </div>
                            <div className="text-area">
                                <p>html</p>
                            </div>
                        </div>
                        <div className="item">
                            <div className="image-area">
                                <img src={css} alt="" />
                            </div>
                            <div className="text-area">
                                <p>Css</p>
                            </div>
                        </div>
                        <div className="item">
                            <div className="image-area">
                                <img src={js} alt="" />
                            </div>
                            <div className="text-area">
                                <p>Javachript</p>
                            </div>
                        </div>
                        <div className="item">
                            <div className="image-area">
                                <img src={bootstrap} alt="" />
                            </div>
                            <div className="text-area">
                                <p>Bootstrap</p>
                            </div>
                        </div>
                        <div className="item">
                            <div className="image-area">
                                <img src={tailwind} alt="" />
                            </div>
                            <div className="text-area">
                                <p>Tailwind Css</p>
                            </div>
                        </div>
                        <div className="item">
                            <div className="image-area">
                                <img src={react} alt="" />
                            </div>
                            <div className="text-area">
                                <p>react.js</p>
                            </div>
                        </div>
                        <div className="item">
                            <div className="image-area">
                                <img src={mui} alt="" />
                            </div>
                            <div className="text-area">
                                <p>material ui</p>
                            </div>
                        </div>

                        <div className="item">
                            <div className="image-area">
                                <img src={redux} alt="" />
                            </div>
                            <div className="text-area">
                                <p>Redux</p>
                            </div>
                        </div>

                        <div className="item">
                            <div className="image-area">
                                <img src={github} alt="" />
                            </div>
                            <div className="text-area">
                                <p>Github</p>
                            </div>
                        </div>
                      
                </div>
            </Tabs.Panel>

            {/* backend  */}
            <Tabs.Panel value="second" pt="xs">
                <div className="technology_grid">
                        <div className="item">
                            <div className="image-area">
                                <img src={node} alt="" />
                            </div>
                            <div className="text-area">
                                <p>nodejs</p>
                            </div>
                        </div>
                        <div className="item">
                            <div className="image-area">
                                <img src={express} alt="" />
                            </div>
                            <div className="text-area">
                                <p>Express.js</p>
                            </div>
                        </div>
                        <div className="item">
                            <div className="image-area">
                                <img src={mongodb} alt="" />
                            </div>
                            <div className="text-area">
                                <p>Mongodb</p>
                            </div>
                        </div>
                        <div className="item">
                            <div className="image-area">
                                <img src={nodemailer} alt="" />
                            </div>
                            <div className="text-area">
                                <p>Nodemailer</p>
                            </div>
                        </div>
                        <div className="item">
                            <div className="image-area">
                                <img src={cloudinary} alt="" />
                            </div>
                            <div className="text-area">
                                <p>Cloudinary</p>
                            </div>
                        </div>
                        <div className="item">
                            <div className="image-area">
                                <img src={heroku} alt="" />
                            </div>
                            <div className="text-area">
                                <p>Heroku</p>
                            </div>
                        </div>
                       
                      
                </div>
            </Tabs.Panel>


            {/* Wordpress */}
          {/* backend  */}
          <Tabs.Panel value="third" pt="xs">
                <div className="technology_grid">
                        <div className="item">
                            <div className="image-area">
                                <img src={wordpress} alt="" />
                            </div>
                            <div className="text-area">
                                <p>Wordpress</p>
                            </div>
                        </div>
                        <div className="item">
                            <div className="image-area">
                                <img src={elementor} alt="" />
                            </div>
                            <div className="text-area">
                                <p>Elementor</p>
                            </div>
                        </div>
                        <div className="item">
                            <div className="image-area">
                                <img src={woocommerce} alt="" />
                            </div>
                            <div className="text-area">
                                <p>Woocommerce</p>
                            </div>
                        </div>
                        <div className="item">
                            <div className="image-area">
                                <img src={mailchimp} alt="" />
                            </div>
                            <div className="text-area">
                                <p>Mailchimp</p>
                            </div>
                        </div>
                        <div className="item">
                            <div className="image-area">
                                <img src={webb} alt="" />
                            </div>
                            <div className="text-area">
                                <p>WPBakery Page Builder</p>
                            </div>
                        </div>
                        <div className="item">
                            <div className="image-area">
                                <img src={astra} alt="" />
                            </div>
                            <div className="text-area">
                                <p>Astra pro</p>
                            </div>
                        </div>

                        <div className="item">
                            <div className="image-area">
                                <img src={divi} alt="" />
                            </div>
                            <div className="text-area">
                                <p>Divi theme</p>
                            </div>
                        </div>
                        <div className="item">
                            <div className="image-area">
                                <img src={pro} alt="" />
                            </div>
                            <div className="text-area">
                                <p>99+ pro plugin</p>
                            </div>
                        </div>

                        <div className="item">
                            <div className="image-area">
                                <img src={protheme} alt="" />
                            </div>
                            <div className="text-area">
                                <p>99+ pro theme</p>
                            </div>
                        </div>
                       
                      
                </div>
            </Tabs.Panel>


            </Tabs>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AboutTechnoloy;
